module.exports = __webpack_public_path__ + "img/next-step.a53285c9.png";